class ProductStickyCart extends HTMLElement {
  connectedCallback() {
    this.form = document.querySelector('[data-product-form]');
    this.primaryButton = this.form?.querySelector('.product-form__submit');
    this.button = this.querySelector('[data-sticky-submit]');
    this.formQuantity = this.form?.querySelector('[name="quantity"]');
    this.stickyQuantity = this.querySelector('[data-sticky-quantity]');
    this.requiresConfiguration = this.dataset.requiresConfiguration === 'true';
    if (!this.form || !this.primaryButton || !this.button) return;

    this.hasSeenPrimary = false;
    this.button.addEventListener('click', () => this.form.requestSubmit(this.primaryButton));
    if (this.formQuantity && this.stickyQuantity) {
      this.stickyQuantity.value = this.formQuantity.value;
      this.stickyQuantity.addEventListener('input', () => {
        this.formQuantity.value = this.stickyQuantity.value;
        this.formQuantity.dispatchEvent(new Event('input', { bubbles: true }));
      });
      this.formQuantity.addEventListener('input', () => {
        this.stickyQuantity.value = this.formQuantity.value;
      });
    }
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) this.hasSeenPrimary = true;
      this.toggle(entry.isIntersecting);
    });
    this.observer.observe(this.primaryButton);

    new MutationObserver(() => this.sync()).observe(this.primaryButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy']
    });
    this.sync();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  toggle(primaryIsVisible) {
    const visible = this.requiresConfiguration ? this.hasSeenPrimary && !primaryIsVisible : true;
    this.classList.toggle('is-visible', visible);
  }

  sync() {
    this.button.disabled = this.primaryButton.disabled;
    this.button.toggleAttribute('aria-busy', this.primaryButton.hasAttribute('aria-busy'));
  }
}

customElements.define('product-sticky-cart', ProductStickyCart);
